import { render, staticRenderFns } from "./BetgameAdminPrivacy.vue?vue&type=template&id=39a5b7b8&scoped=true"
import script from "./BetgameAdminPrivacy.vue?vue&type=script&lang=js"
export * from "./BetgameAdminPrivacy.vue?vue&type=script&lang=js"
import style0 from "./BetgameAdminPrivacy.vue?vue&type=style&index=0&id=39a5b7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a5b7b8",
  null
  
)

export default component.exports